/**
 * @param {number} a
 * @param {number} b
 * @returns {number}
 */
export function add(a, b) {
	return a + b;
}
